import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { activateSentry } from './helpers';
// Log the app version in the console
console.log('ver. ', import.meta.env.VITE_REACT_APP_VERSION);

const hasSentryCookie = localStorage.getItem("cookie_consent_sentry");
if(hasSentryCookie == "true"){
  activateSentry();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
